import { useTrackingStore } from '@listening/frontend/analytics/tracking-params-store';
import { useEffect } from 'react';

export function useTrackingCapture() {
  const setTrackingParams = useTrackingStore((s) => s.setTrackingParams);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const params = new URLSearchParams(window.location.search);

    const gclid = params.get('gclid');
    const wbraid = params.get('wbraid');
    const gbraid = params.get('gbraid');
    const fbclid = params.get('fbclid');
    const utmSource = params.get('utm_source');
    const utmMedium = params.get('utm_medium');
    const utmCampaign = params.get('utm_campaign');
    const utmTerm = params.get('utm_term');
    const utmContent = params.get('utm_content');

    const trackingParams: Parameters<typeof setTrackingParams>[0] = {};

    if (gclid) trackingParams.google_click_id = gclid;
    if (wbraid) trackingParams.google_wbraid = wbraid;
    if (gbraid) trackingParams.google_gbraid = gbraid;
    if (fbclid) trackingParams.facebook_click_id = fbclid;
    if (utmSource) trackingParams.utm_source = utmSource;
    if (utmMedium) trackingParams.utm_medium = utmMedium;
    if (utmCampaign) trackingParams.utm_campaign = utmCampaign;
    if (utmTerm) trackingParams.utm_term = utmTerm;
    if (utmContent) trackingParams.utm_content = utmContent;

    if (Object.keys(trackingParams).length > 0) {
      setTrackingParams(trackingParams);
    }
  }, [setTrackingParams]);
}
